var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.returns'),"name":"ordersReturns","url":_vm.$listRoutes.ordersReturns,"table":_vm.ordersReturns,"filters":_vm.ordersReturnsFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }